import * as React from "react"
const EcommerceSVG = (props) => (
  <svg 
    xmlns="http://www.w3.org/2000/svg" 
    viewBox="0 0 64 64" 
    fill={'whitesmoke'} 
    {...props
  }>
    <g data-name="40 shopping online">
      <path d="M54.41 45.24a1.02 1.02 0 1 1-1.02-1.02 1.024 1.024 0 0 1 1.02 1.02ZM50.33 45.24a1.015 1.015 0 1 1-1.02-1.02 1.018 1.018 0 0 1 1.02 1.02Z" />
      <path d="M58.5 40.68h-3.09V17.19a3.009 3.009 0 0 0-3-3H11.59a3.009 3.009 0 0 0-3 3v23.49H5.5a2 2 0 0 0-2 2v1.13a6.011 6.011 0 0 0 6 6h45a6.011 6.011 0 0 0 6-6v-1.13a2 2 0 0 0-2-2ZM10.59 17.19a1 1 0 0 1 1-1h40.82a1 1 0 0 1 1 1v23.49H10.59Zm27.94 25.49-1.04 2.07H26.51l-1.04-2.07Zm19.97 1.13a4.005 4.005 0 0 1-4 4h-45a4.005 4.005 0 0 1-4-4v-1.13h17.73l1.76 3.52a1 1 0 0 0 .9.55h12.22a1 1 0 0 0 .9-.55l1.76-3.52H58.5Z" />
      <path d="M43.2 26.42h-3.04l-4.84-7.25a1 1 0 1 0-1.66 1.11l4.09 6.14h-11.5l4.09-6.14a1 1 0 1 0-1.66-1.11l-4.84 7.25H20.8a1 1 0 1 0 0 2h.78l1.3 7.42a3.2 3.2 0 0 0 3.07 2.76h12.1a3.2 3.2 0 0 0 3.07-2.76l1.3-7.42h.78a1 1 0 0 0 0-2Zm-4.05 9.08a1.212 1.212 0 0 1-1.1 1.1h-12.1a1.212 1.212 0 0 1-1.1-1.1l-1.24-7.08h16.78Z" />
      <path d="M32 35.546a1 1 0 0 0 1-1v-4.073a1 1 0 0 0-2 0v4.073a1 1 0 0 0 1 1ZM27.926 35.546a1 1 0 0 0 1-1v-4.073a1 1 0 0 0-2 0v4.073a1 1 0 0 0 1 1ZM36.074 35.546a1 1 0 0 0 1-1v-4.073a1 1 0 0 0-2 0v4.073a1 1 0 0 0 1 1Z" />
    </g>
  </svg>
)
export default EcommerceSVG;
